import {FC, useMemo, useState} from 'react'
import {CForm, FieldTProps} from '../../../_component/Form'
import clsx from 'clsx'
import {fields} from '../../modules/apps/admission/admissions-list/core/_models'
import {
  createAdmission,
  updateAdmission,
} from '../../modules/apps/admission/admissions-list/core/_requests'
import {Link} from 'react-router-dom'
import {QUERIES} from '../../../_metronic/helpers'

export const AdmissionPage: FC = () => {
  const [completed, setCompleted] = useState(false)
  const [canceled, setCanceled] = useState(false)
  const [step, setStep] = useState(0)
  const fields1 = useMemo(() => {
    setStep(0)
    const res: FieldTProps[] = []
    ;(typeof fields === 'function' ? fields() : fields)?.forEach((level: any) => {
      const fields = level.fields?.filter((field: any) => {
        if (field.type === 'multi-input' && field.fields instanceof Array)
          field.fields.some((f: any) => f.create !== false)
        return field.create !== false
      })
      if (fields?.length) {
        res.push({...level, fields})
      }
    })
    return res
    // eslint-disable-next-line
  }, [])
  return (
    <div id='kt_app_content' className='app-content flex-column-fluid mt-5'>
      {/*begin::Content container*/}
      <div id='kt_app_content_container' className='app-container container-xxl'>
        <div className='card'>
          <div className='card-header'>
            <h2 className='card-title m-auto'>Application Form</h2>
          </div>
          {/*begin::Admission*/}
          {completed ? (
            <div className='scroll-y m-xl-5'>
              <div className='alert alert-success'>Application Saved Successfully</div>
              <Link to='/' className='btn btn-outline-primary me-2'>
                Back to HomePage
              </Link>
              <button
                className='btn btn-primary'
                onClick={() => {
                  setCanceled(false)
                  setCompleted(false)
                  setStep(0)
                }}
              >
                Start a New Application
              </button>
            </div>
          ) : canceled ? (
            <div className='scroll-y m-xl-5'>
              <div className='alert alert-danger'>Operation cancelled</div>
              <Link to='/' className='btn btn-outline-primary me-2'>
                Back to HomePage
              </Link>
              <button
                className='btn btn-primary'
                onClick={() => {
                  setCanceled(false)
                  setCompleted(false)
                  setStep(0)
                }}
              >
                Start a New Application
              </button>
            </div>
          ) : (
            <div className='scroll-y m-xl-5'>
              <div className='d-flex border-bottom mb-6'>
                {fields1.map((level, index) => (
                  <div
                    key={index}
                    className={clsx('nav-link cursor-pointer px-4 py-2 fw-bold', {
                      'active text-primary border-bottom border-3 border-primary': index === step,
                      'text-muted': index !== step,
                    })}
                  >
                    {level.title}
                  </div>
                ))}
              </div>
              {fields1.length ? (
                <CForm
                  model={QUERIES.ADMISSIONS_LIST}
                  data={undefined}
                  update={updateAdmission}
                  create={createAdmission}
                  fields={fields as any}
                  tabFields={fields1}
                  tab={{step, setStep, steps: fields1.length - 1}}
                  refetch={() => setCompleted(true)}
                  setItemIdForUpdate={() => setCanceled(true)}
                />
              ) : null}
              {/* <EditModalFormWrapper /> */}
            </div>
          )}
          {/*end::Admission*/}
        </div>
      </div>
      {/*end::Content container*/}
    </div>
  )
}
